<div (click)="selectTints(tint.catalogCode)" [id]="tintIdPrefix + tint?.catalogCode"
    [ngClass]="{'selectedTint': (selectedTint$ | async) == tint?.catalogCode, 'disabled-combination': hasTintRestrictions(tint)}"
    vcldAutomationId="consr_app-tint-host_tint-lens_tile" class="col s12 platinum tint-tile">
    <img *ngIf="thumbnail; else fallbackIcon" [src]="thumbnail" class="filter-icon visucloud-icons tint-icon-style">

    <ng-template #fallbackIcon>
        <img src="../../../../assets/images/shine.png" class="filter-icon tint-icon-style" [ngStyle]="{'background-image': _tintsCoatings.getThumbnailStyle(tint),'background-color': '#eee'}">
    </ng-template>
    <p vcldTooltip>{{_tintsCoatings.getTintUIName(tint)}}<br>{{_tintsCoatings.getTintUIValue(tint)}}</p>
</div>